import { keyBy, mapValues } from 'lodash';
import Cookies from 'universal-cookie';

import type { Message } from '@swf/core/api/request';
import type { ModelConfig } from '@swf/core/store';
import type { Account } from '@swf/core/types/Account';
import CookieNames from '@swf/core/types/Cookies';
import type {
  Counter,
  ForceLogoutNotification,
  GeoComplyPLC,
  InactivityMessage,
  LobbyNotification,
  LoginEventNotification,
  Notification,
  RawNotification,
  SuspendAccount
} from '@swf/core/types/Notification';

import effects from './effects';
import reducers from './reducers';
import selectors from './selectors';

export enum TokenInvalidReason {
  EXPIRE = 1,
  ADMIN_FORCE_LOGOUT = 2,
  SESSION_TRANSFERED = 3,
  PLAYING_TIME_REACHED = 4,
  EXPLICIT_LOGOUT = 5,
  APP_SESSION_DELETED = 6,
  PWS_CHAGE = 7,
  NOT_ALLOWED_TO_PLAY = 9
}

export enum LoginEventType {
  ValidateAccountReminder = 1,
  SuspendedDocumentsSubmission = 3,
  AccountVerification = 5
}

export enum ErrorCode {
  INSUFFICIENT_FUNDS = 5
}

export interface NotificationStateProps {
  submitted?: boolean;
  hasError?: boolean;
  clearbets?: number;
  notificationid?: number;
  rollid?: number;
  errorCode?: ErrorCode;
}

interface NotificationBody {
  notification:
    | RawNotification
    | Account
    | LoginEventNotification
    | LobbyNotification
    | ForceLogoutNotification
    | GeoComplyPLC
    | SuspendAccount;
}

export type NotificationMessage = Message<NotificationBody | InactivityMessage, { type: string }>;

export interface NotificationState {
  issued: Record<string, Notification>;
  expiring: Record<string, Notification>;
  cleared: Record<string, Notification>;
  counters: Counter;
  cookies: {
    [CookieNames.COOKIE_NOTIFICATION]?: boolean;
    [CookieNames.DOWNLOAD_BANNER]?: boolean;
    [CookieNames.ADD_TO_HOME_SCREEN]?: boolean;
  };
}

interface NotificationModel extends ModelConfig<NotificationState> {
  reducers: typeof reducers;
  effects: typeof effects;
  selectors: typeof selectors;
}

const cookies = new Cookies();
const notification: NotificationModel = {
  state: {
    issued: {},
    expiring: {},
    cleared: {},
    counters: {
      freeBetCounter: 0,
      freeSpinCounter: 0,
      instantBonusCounter: 0,
      prizeGameCounter: 0
    },
    cookies: mapValues(
      keyBy([
        CookieNames.COOKIE_NOTIFICATION,
        CookieNames.DOWNLOAD_BANNER,
        CookieNames.ADD_TO_HOME_SCREEN
      ]),
      (name) => cookies.get(name) !== 'false'
    )
  },
  effects,
  reducers,
  selectors
};

export default notification;
